import './index.css';
import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

import App from './App';
import NewVendor from './Vendors/NewVendor';
import SetPassword from './SetPassword/SetPassword';
import NewCustomer from './Customers/NewCustomer';
import NoPage from './NoPage/NoPage'
import CostCode from './CostCode/CostCode';
import TechApp from './FieldService/TechApp';
import QCViewer from './QualityControl/QCViewer';
import ProcurementLinks from './ProcurementTracker/ProcurementLinks';
import TechEquipment from './FieldService/TechEquipment';

// ROUTES
export default function PrimaryRoute() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<App />} />
          <Route path="newVendor" element={<NewVendor />} />
          <Route path="newVendor/:email" element={<NewVendor />} />
          <Route path="updateVendor/:vendorNumber/:sessionId" element={<NewVendor />} />
          <Route path="newCustomer" element={<NewCustomer />} />
          <Route path="newCustomer/:email" element={<NewCustomer />} />
          <Route path="newCustomer/:sessionId/:rejectionId" element={<NewCustomer />} />
          <Route path="updateCustomer/:customerNumber/:sessionId" element={<NewCustomer />} />
          <Route path="AppointmentViewer/:appointmentNumber/:sessionId" element={<TechApp />} />
          <Route path="EquipmentViewer/:sessionId/:customerId/:locationId" element={<TechEquipment />} />
          <Route path="setPassword" element={<SetPassword />} />
          <Route path="costCodeLookup" element={<CostCode />} />
          <Route path="QCViewer/:sessionId/:projectId" element={<QCViewer />} />
          <Route path="ProcurementPortal/:sessionId" element={<ProcurementLinks />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<PrimaryRoute />);
